export default __webpack_public_path__ + "static/media/28.a4e2db16.png";